export enum Standards {
  Elite = "ELITE",
  Friendly = "FRIENDLY",
  GrassRoot = "GRASS_ROOT",
  International = "INTERNATIONAL",
  NoncontinentalChampionship = "NONCONTINENTAL_CHAMPIONSHIP",
  Olympic = "OLYMPIC",
  Region = "REGION",
  Tier2 = "TIER2",
  Tier3 = "TIER3",
  WorldChampionship = "WORLD_CHAMPIONSHIP",
  ZoneChampionship = "ZONE_CHAMPIONSHIP",
  Olympics = "OLYMPICS",
  FihWorldCup = "FIH_WORLD_CUP",
  FihOlympicQualifiers = "FIH_OLYMPIC_QUALIFIERS",
  FihWorldCupQualifiers = "FIH_WORLD_CUP_QUALIFIERS",
  ContinentalChampionship = "CONTINENTAL_CHAMPIONSHIP",
  FihProLeague = "FIH_PRO_LEAGUE",
  CommonwealthGames = "COMMONWEALTH_GAMES",
  FihNationsCup = "FIH_NATIONS_CUP",
  ContinentalQualifier = "CONTINENTAL_QUALIFIER",
  ContinentalChampionshipDiv2 = "CONTINENTAL_CHAMPIONSHIP_DIV_2",
  ContinentalChampionshipDiv3 = "CONTINENTAL_CHAMPIONSHIP_DIV_3",
  InvitationalTournament = "INVITATIONAL_TOURNAMENT",
  ContinentalChampionshipDiv4 = "CONTINENTAL_CHAMPIONSHIP_DIV_4",
  ApprovedTestMatches = "APPROVED_TEST_MATCHES",
  WorldLeague = "WORLD_LEAGUE",
  HockeySeriesOpen = "HOCKEY_SERIES_OPEN",
  HistoricalBaseline = "HISTORICAL_BASELINE",
}
